import { Col, Form, Input, Row, Space, Button } from 'antd';
import React, { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Modal from '../../../main/components/Modal';
import { CellFullName } from '../../components/UserList';
import SelectUser from '../Selects/SelectUser';
import DateRangeComponent from './DateRangeComponent';
import GlobalContext from '../../../main/utils/GlobalContext';

const ModalCreateEstablishment = ({
  visible = false,
  onClose,
  onFinish,
  uploading,
}) => {
  const [adminOptions, setAdminOptions] = useState([]);

  const {
    admin: {
      adminOptions: { collection: adminList, loading: adminLoading },
      createdAdmins,
    },
  } = useSelector((state) => state);

  const {
    admin: { fetchAdmins, addCreatedAdmin, removeCreatedAdmin },
  } = useDispatch();

  const { locales } = useContext(GlobalContext);

  useEffect(() => {
    const establishmentId = 23;
    fetchAdmins({ establishmentId });
  }, []);

  useEffect(() => {
    if (adminList) {
      setAdminOptions(adminList);
    }
  }, [adminList]);

  const [form] = Form.useForm();

  const handleSelect = (userId) => {
    addCreatedAdmin({ userId });
  };

  const handleDelete = (userId) => {
    removeCreatedAdmin({ userId });
  };

  const handleFinish = (values) => {
    values.maxLicensesCount = Number(values.maxLicensesCount);
    values.licenceLength = Number(values.licenceLength);
    values.createdAdmins = createdAdmins.map((e) => e.id);
    const afterSuccess = () => {
      form.resetFields();
    };
    onFinish(values, afterSuccess);
  };

  return (
    <Modal
      className="sm"
      isOpen={visible}
      onClose={onClose}
      title={locales.admin.createNewEstablishment}
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <div className="mt-20">
          <Row gutter={30}>
            <Col>
              <Form.Item
                label={locales.admin.name}
                className="admin-input-label"
                name="name"
                rules={[
                  { required: true, message: locales.admin.nameIsRequired },
                ]}
              >
                <Input
                  placeholder={locales.admin.addNameOfEstablishment}
                  className="admin-input"
                />
              </Form.Item>
              <Form.Item
                label={locales.admin.subdomain}
                className="admin-input-label"
                name="subdomain"
                rules={[
                  {
                    required: true,
                    message: locales.admin.subdomainIsRequired,
                  },
                ]}
              >
                <Input
                  placeholder={locales.admin.addEstablishmentsSubdomain}
                  className="admin-input"
                />
              </Form.Item>
              <Row gutter={10}>
                <DateRangeComponent form={form} locales={locales} />
              </Row>
              <SelectUser
                avatarVisible
                users={adminOptions}
                loading={uploading || adminLoading}
                columns={[
                  {
                    dataIndex: 'email',
                    render: (row) => {
                      return <CellFullName user={row} />;
                    },
                  },
                ]}
                labelOfSelect={
                  locales.admin.inviteAdminsToJoinYourEstablishment
                }
                placeholderOfSelect={locales.admin.chooseAdminByEmail}
                labelOfList={locales.admin.admins}
                selectedIds={createdAdmins.map((admin) => admin.id)}
                onSelect={handleSelect}
                onDelete={handleDelete}
              />
            </Col>
            <Col>
              <Form.Item
                label={locales.admin.totalLicence}
                className="admin-input-label"
                name="maxLicensesCount"
                rules={[
                  {
                    pattern: '^[0-9]\\d*$',
                    message: locales.admin.inputMustBePositiveNumber,
                  },
                ]}
              >
                <Input
                  type="number"
                  placeholder={locales.admin.addNumber}
                  className="admin-input"
                />
              </Form.Item>
              <Form.Item
                label={locales.admin.licenceLength}
                className="admin-input-label"
                name="licenceLength"
                rules={[
                  {
                    pattern: '^[0-9]\\d*$',
                    message: locales.admin.inputMustBePositiveNumber,
                  },
                ]}
              >
                <Input
                  type="number"
                  placeholder={locales.admin.days}
                  className="admin-input"
                />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div className="flex align-right mt-20">
          <Space>
            <Button onClick={onClose} disabled={uploading}>
              {locales.admin.cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={uploading}>
              {locales.admin.create}
            </Button>
          </Space>
        </div>
      </Form>
    </Modal>
  );
};

ModalCreateEstablishment.propTypes = {
  visible: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired,
  uploading: PropTypes.bool,
};
export default ModalCreateEstablishment;
